import { Injectable } from '@angular/core';

import {
  decodeToken as decodeTokenFn,
  getOrganisationId as getOrgId,
  getOrganisationUserId as getOrgUserId,
  getUserRoles as getUserRolesFn,
  isTokenValid as isTokenValidFn,
  urlBase64Decode as urlBase64DecodeFn,
} from './jwt-helper';

/**
 * Thin injectable wrapper around standalone JWT helper functions.
 * Single source of truth for JWT logic lives in jwt-helper.ts.
 */
@Injectable({
  providedIn: 'root',
})
export class JwtHelperService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  urlBase64Decode(str: string) {
    return urlBase64DecodeFn(str);
  }

  decodeToken(token: string): any {
    return decodeTokenFn(token);
  }

  isTokenValid(token: any) {
    return isTokenValidFn(token);
  }

  getUserRoles(decodedToken: any) {
    return getUserRolesFn(decodedToken);
  }

  getOrganisationId(decodedToken: any) {
    return getOrgId(decodedToken);
  }

  getOrganisationUserId(decodedToken: any) {
    return getOrgUserId(decodedToken);
  }

  isUserSuperUser(jwtToken: any) {
    if (jwtToken) {
      const decodedToken = this.decodeToken(jwtToken);

      if (decodedToken) {
        const res = decodedToken.roles.find((x: any) => x.name == 'SUPERUSER');
        if (res) {
          return true;
        } else {
          return false;
        }
      }
    }

    return null;
  }

  // doesUserHaveRoleOfType();

  doesUserHaveRoleOfType(rolesToCheck: string[], jwtToken: any) {
    if (jwtToken && rolesToCheck) {
      const decodedToken = this.decodeToken(jwtToken);

      let exists;
      if (decodedToken.roles) {
        decodedToken.roles.forEach((role: any) => {
          exists = rolesToCheck.find((r) => r == role.name);
        });
      }

      if (exists) {
        return true;
      }
    }
    return false;
  }
}
